import { useCallback, useMemo } from 'react';

const usePixel = () => {
  const handleEnable = useCallback((src?: string) => {
    if (typeof document === 'undefined' || !src) {
      return;
    }
    let pixel = (document.querySelector(`img.pixel[src="${src}"]`) as HTMLImageElement | null);
    if (pixel) {
      return;
    }
    pixel = (document.createElement('img') as HTMLImageElement);
    pixel.classList.add('pixel');
    pixel.style.position = 'absolute';
    pixel.style.top = '0';
    pixel.style.left = '0';
    pixel.style.width = '1px';
    pixel.style.height = '1px';
    pixel.style.opacity = '0';
    document.body.appendChild(pixel);
    pixel.setAttribute('data-status', 'triggered');
    pixel.setAttribute('src', src);
  }, []);

  const handleDisable = useCallback((src: string) => {
    const pixel = (document.querySelector(`img.pixel[src="${src}"]`) as HTMLImageElement | null);
    if (!pixel) {
      return;
    }
    pixel.remove();
  }, []);

  return useMemo(() => ({
    enable: (src?: string) => {
      handleEnable(src);
    },
    disable: (src: string) => {
      handleDisable(src);
    },
  }), [handleEnable, handleDisable]);
};

export default usePixel;
